<template>
  <div class="mx-5 mt-4">
    <div>
      <h4 class="font-weight-bold">Share {{realName}}</h4>
      <template v-if="!isLoaded">
        <div class="placeholder placeholder-chart mb-1" :style="'width: ' + 100 + '%'"></div>
        <div class="placeholder placeholder-sentence mb-1" :style="'width: ' + 100 + '%'"></div>
        <div class="placeholder placeholder-sentence mb-1" :style="'width: ' + 100 + '%'"></div>
      </template>
      <template v-else>
        <div v-if="!gotEncryptedString">
          <button class="btn btn-first mr-2" @click="generateEncryptedString()">Generate Share Link</button>
        </div>
        <div v-else>
          <div class="mb-4 text-center">
            <b v-if="!isPublicLink">
              <img src="../assets/img/disallow-link.png"/>
              <br>
              Access Restricted
            </b>
            <b v-if="isPublicLink">
              <img src="../assets/img/allow-link.png" />
              <br>
              Public Accessible
            </b>
          </div>
          
          <div class="row" style="justify-content: space-evenly;padding-bottom: 20px;">
            <div class="col-md-12">
              <input type="hidden" class="form-control cursor-pointer" v-model="publicUrl" readonly @click="copyLink()">
            </div>
          </div>
          <div class="row" style="justify-content:space-evenly">
            <div class="col-md-12">
              <p class="font-weight-bold" style="margin-bottom:5px">Access setting</p>

              <select id="shareSettings" v-model="isPublicLink" @change="saveSettings()" class="custom-select">
                <option id="private" :value="false">No one can view the link</option>
                <option id="public" :value="true">Anyone with the link can view</option>
              </select>
            </div>
          </div>
          <div class="row mt-3" style="justify-content:space-evenly">
            <div class="col-md-6">
              <button class="btn btn-outline-muted" @click="copyLink()"><font-awesome-icon icon="link" class="mr-2 fa-sm " /> <span class="">Copy Link</span></button>
              <p class="text-white text-center py-2 mt-2 d-inline-block px-4" v-bind:style="linkCopied ? 'opacity: 1' : 'opacity: 0'" style="border-radius: 4px;background-color: #313131">{{ t('Link copied') }}</p>     
            </div>     
            <div class="col-md-6 text-right">
              <button class="btn btn-outline-muted" @click="$modal.hide($parent.name)">Done</button>
            </div>                 
          </div>   
          
          
        </div>        
      </template>      
    </div>
  </div>
</template>
<script>
  /* eslint-disable */
  export default {
    data: function() {
      return {
        publicUrl: '',
        isLoaded: false,
        currentProtocol: window.location.protocol,
        currentHost: window.location.host,
        isPublicLink: false,
        encryptedString: null,
        secretPosition: 17,
        isShareSession: false,
        moduleName: '',
        realName: '',
        popUpName: '',
        linkCopied: false,
        saved: false,
        randomStrings: '',
        gotEncryptedString: false,
        bodyUrlNaming: '',
        isFirstTime: true,
        copyTimeout: null
      }
    },
    props: [
      'public',
    ],    
    beforeMount() {

      //this.checkForFlag()
      this.moduleName = (this.$route.name.includes('ViewPolls')) ? 'Survey' : this.$route.name
      if (this.public) this.isPublicLink = this.public

      this.checkforFirstTime()
      this.changeForDisplayName()

      console.log(this.public)

    },
    mounted() {},
    methods: {
      saveSettings() {
        this.copyLink();

        let unique_id = this.$route.params.feedbackId || this.$route.params.test_id || this.$route.params.id || this.$route.params.pollGroupId || 0
        this.$http.post(process.env.API_ENDPOINT + '/updateSharePermission', {
          widget_id: this.$session.get('widget_id'),
          company_id: this.$session.get('company_id'),
          flag: ((this.isPublicLink === true) ? 0 : 1),
          created_by: this.$session.get('email'),
          updated_by: this.$session.get('email'),
          modules: this.$route.name,
          unique_module_id: unique_id,
          event_type: ((this.$route.name.includes('EventsDetail')) ? this.$route.params.key : ''),
          event_name: ((this.$route.name.includes('EventsDetail')) ? this.$route.params.value : ''),
        }).then(() => {
          this.saved = true
          this.$awn.success('Access updated', {
            position: 'bottom-right',
            maxNotifications: 1,
          })   
          setTimeout(() => {
            this.saved = false
          }, 1500);
          this.$emit('permissionChanged', this.isPublicLink);
          this.checkForFlag()
        })
      },
      generateDomain() {
        this.$http.get(process.env.API_ENDPOINT + '/getSpecificShareEnc').then((result) => {
          console.log(result.data[0])
          if (result.data[0] === undefined) {
            this.generateEncryptedString()
          } else {
            this.randomStrings = result.data[0].encrypted_url
          }
          let domain = ''
          //let domain = 'https://app.howuku.com'
          if (window.location.host.includes('localhost')) {
            domain = 'http://localhost:8080/'
          } else {
            domain = `https://${this.currentHost}/`
          }
          let bodyUrl = ''
          if (this.$route.name.includes('Analytics')) {
            bodyUrl = 'share/analytics/'
          } else if (this.$route.name.includes('ViewFeedback')) {
            bodyUrl = 'share/feedback/' + this.$route.params.feedbackId + '/'
          } else if (this.$route.name.includes('EventsDetail')) {
            let arr = []
            if (this.$route.params.value.includes('&')) {
              arr = this.$route.params.value.split('&')
            }
            bodyUrl = 'share/events/' + this.$route.params.key + '/' + arr[0] + '&' + arr[1] + '/'
          } else if (this.$route.name === 'Experiment') {
            bodyUrl = 'share/abtest/'
          } else if (this.$route.name === 'Experiment Result') {
            bodyUrl = 'share/abResult/' + this.$route.params.test_id + '/'
          } else if (this.$route.name.includes('ViewPolls')) {
            bodyUrl = 'share/survey/' + this.$route.params.pollGroupId + '/'
          } else if (this.$route.name.includes('Form Result')) {
            bodyUrl = 'share/form/result/' + this.$route.params.id + '/'
          } else if (this.$route.name.includes('Funnel Flow')) {
            bodyUrl = 'share/funnel/' + this.$route.params.id + '/' + this.$route.params.id_name + '/'
          } else {
            bodyUrl = 'share/dashboard/'
          }
          this.publicUrl = this.currentProtocol + '//' + this.currentHost + '/' + bodyUrl + this.randomStrings
        })
      },
      copyLink() {
        clearTimeout(this.copyTimeout)
        this.linkCopied = true
        this.copyTimeout = setTimeout(() => {
          this.linkCopied = false
        }, 1500);
        
        let url = this.publicUrl
        const urlParams = new URLSearchParams(window.location.search)
        const startDate = urlParams.get('startDate')
        const endDate = urlParams.get('endDate')
        
        if (startDate && endDate) {
          url += `?startDate=${startDate}&endDate=${endDate}`
        } else if (startDate) {
          url += `?startDate=${startDate}`
        } else if (endDate) {
          url += `?endDate=${endDate}`
        }

        navigator.clipboard.writeText(url)
      },
      generateEncryptedString() {
        var loop = false
        do {
          this.randomStrings = '';
          var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
          var charactersLength = characters.length;
          for (var i = 0; i < 8; i++) {
            this.randomStrings += characters.charAt(Math.floor(Math.random() * charactersLength));
          }
          let flag = false
          this.$http.get(process.env.API_ENDPOINT + '/getAllShareEnc').then((result) => {
            let data = result.data[0]
            for (let i = 0; i < data.length; i++) {
              const element = data[i];
              if (data[i] === randomStrings) {
                flag = true
              }
            }
            loop = flag
          })
        } while (loop === true);
        this.saveDatas()
        this.checkForFlag()
        this.gotEncryptedString = true
      },
      saveDatas() {
        let data = {
          company_id: this.$session.get('company_id'),
          encrypted_url: this.randomStrings,
          datas: {
            widget_id: this.$session.get('widget_id'),
            jwt: this.$session.get('jwt'),
            widget_name: this.$session.get('widget_name'),
            startDate: (this.$store.getters.datepicker.dashboard.startDate || this.$userTimeNow().add(-7, 'day').format('YYYY-MM-DD')),
            endDate: (this.$store.getters.datepicker.dashboard.endDate || this.$userTimeNow().format('YYYY-MM-DD')),
          },
          created_by: this.$session.get('email'),
        }
        this.$http.post(process.env.API_ENDPOINT + '/updateShareLinkData', data)
        .then(() => {
          
        })
      },
      changeForDisplayName() {
        if (this.moduleName === 'ViewFeedback') {
          this.realName = 'feedback responses'
        } else if (this.moduleName === 'A/B Result') {
          this.realName = 'A/B test'
        } else if (this.moduleName === 'Survey') {
          this.realName = 'Survey responses'
        } else if (this.moduleName === 'EventsDetail') {
          this.realName = 'Event'
        } else if (this.moduleName === 'Funnel Flow') {
          this.realName = 'Funnel'
        } else {
          this.realName = this.moduleName
        }
      },
      checkForFlag() {
        this.$http.get(process.env.API_ENDPOINT + '/sharePermission').then(result => {
          for (let index = 0; index < result.data.length; index++) {
            const element = result.data[index];
            console.log('checkforflag')
            console.log(element)
            if (element.modules === this.$route.name) {
              console.log(element.modules, this.$route.name)
              if (element.unique_module_id !== 0) {
                if (parseInt(this.$route.params.feedbackId) === element.unique_module_id || parseInt(this.$route.params.test_id) === element.unique_module_id || parseInt(this.$route.params.id) === element.unique_module_id || parseInt(this.$route.params.pollGroupId) === element.unique_module_id) {
                  this.isPublicLink = (element.flag === 0) ? true : false
                }
              } else {
                console.log(this.$route.params.key)
                if (this.$route.params.key && this.$route.params.value) {
                  if (this.$route.params.key === element.event_type && this.$route.params.value === element.event_name) {
                    this.isPublicLink = (element.flag === 0) ? true : false
                  }
                } else {
                  this.isPublicLink = (element.flag === 0) ? true : false
                }
              }
            }
          }
        }).then(() => {
          if (this.isPublicLink === false) {
            document.getElementById('shareSettings').value = false
          } else {
            document.getElementById('shareSettings').value = true
          }
          this.$emit('permissionChanged', this.isPublicLink);
        })
      },
      checkforFirstTime() {
        this.$http.get(process.env.API_ENDPOINT + '/getSpecificShareEnc').then((result) => {
          if (result.data[0]) {
            this.gotEncryptedString = true
            this.isFirstTime = false
          }
          if (!this.isFirstTime) {
            this.generateDomain()
          }
          this.isLoaded = true
        })
      }
    },
  }
</script>
<style scoped>
  .shareLinkBtn {
    border-color: rgba(var(--main-color), 1);
    background-color: transparent;
  }

  .shareLinkBtn:hover {
    background-color: rgba(var(--main-color), .1) !important;
  }

  #snackbar {
    visibility: hidden;
    min-width: 150px;
    margin-left: -125px;
    background-color: #333;
    color: #fff;
    text-align: center;
    border-radius: 10px;
    padding: 16px;
    position: fixed;
    z-index: 99;
    right: 15px;
    bottom: 15px;
  }

  #snackbar.show {
    visibility: visible;
    -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
    animation: fadein 0.5s, fadeout 0.5s 2.5s;
  }

  @-webkit-keyframes fadein {
    from {
      bottom: 0;
      opacity: 0;
    }

    to {
      bottom: 15px;
      opacity: 1;
    }
  }

  @keyframes fadein {
    from {
      bottom: 0;
      opacity: 0;
    }

    to {
      bottom: 15px;
      opacity: 1;
    }
  }

  @-webkit-keyframes fadeout {
    from {
      bottom: 15px;
      opacity: 1;
    }

    to {
      bottom: 0;
      opacity: 0;
    }
  }

  @keyframes fadeout {
    from {
      bottom: 15px;
      opacity: 1;
    }

    to {
      bottom: 0;
      opacity: 0;
    }
  }

  .tooltip-pop {
    border: 1px solid;
  }

  .tooltip-pop:before,
  *[data-toggle="tooltip"]:before {
    margin-left: -74px;
    margin-bottom: 5px;
    min-width: 100px;
  }

  .tooltip-pop::after {
    margin-bottom: 0px;
  }

  .tooltip-2:before {
    margin-left: -64px !important;
  }

  .generatedUrl {
    font-size: 16px;
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
    width: 80%;
    margin: 10px 0px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/shareSetting.vue